export const getSession = () => {
  try {
    const session = localStorage.getItem('veiassistent_session');
    return session ? JSON.parse(session) : null;
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  return getSession() !== null;
};

export const logout = (navigate) => {
  localStorage.removeItem('veiassistent_session');
  if (navigate) {
    navigate('/login');
  } else {
    window.location.href = '/login';
  }
};

export const upgradeAccount = (billingInfo) => {
  try {
    const session = getSession();
    if (!session) return false;
    const updatedSession = { 
      ...session, 
      accountTier: 'premium', 
      billingInfo,
      subscriptionStartDate: new Date()?.toISOString()
    };
    localStorage.setItem('veiassistent_session', JSON.stringify(updatedSession));
    const users = JSON.parse(localStorage.getItem('veiassistent_users') || '[]');
    const userIndex = users?.findIndex(u => u?.id === session?.id);
    if (userIndex !== -1) {
      users[userIndex] = { ...users?.[userIndex], accountTier: 'premium' };
      localStorage.setItem('veiassistent_users', JSON.stringify(users));
    }
    return true;
  } catch {
    return false;
  }
};
